<!-- 定义全局变量 -->
<script type="text/javascript">
// ******默认url链接********
var urlBase="https://m-jxjy.ahharc.com/api"; 

// ******图片链接********
var imgBase="https://www.ahsjxjy.com";

export default
{
  urlBase,
  imgBase
}
</script>



// WEBPACK FOOTER //
// global.vue?2d82e913